import React from 'react';
import { SearchBar as OriginalSearchBar } from 'antd-mobile';
const SearchBar = (props) => {
    return (React.createElement("div", null,
        React.createElement(OriginalSearchBar, Object.assign({}, props))));
};
export default SearchBar;
